import React, { useState } from "react";
import { useDispatch } from "react-redux";
import _ from 'lodash'

//Helpers
import { Button, DropDownField, TextAreaField, TextInputField } from "../../../helpers"

//Initial values
import { processCreditNoteInitialValues, processCreditNoteValidationSchema } from "../../../validation/stockAdjustment";

//APIs
import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { validateInputs } from "../../../utils";
import { getCreditNotesWithRejectedStock } from "../../../services/api/stockWarehouse";
import Loading from "../../../common/Loading";


const ProcesCreditNote = () => {

    const [processCreditNote, setProcessCreditNote] = useState(processCreditNoteInitialValues)
    const [creditNoteItems, setCreditNoteItems] = useState([])
    const [materialDetails, setMaterialDetails] = useState([])
    
    const [isLoading, setIsLoading] = useState(false)

    const [formErrors, setFormErrors] = useState({})

    const dispatch = useDispatch()


    const handleProcessCreditNoteChange = (e) => {
        if(e.target.name === "materialId"){
            const relatedCreditNoteItem = creditNoteItems.find(eachNoteItem => eachNoteItem.materialId === e.target.value)
            processCreditNote['creditNoteQty'] = relatedCreditNoteItem?.adjustedQty ? relatedCreditNoteItem.adjustedQty : null
        }

        if(e.target.name === "processedQty"){
            if(!processCreditNote['creditNoteQty']){
                return dispatch(raiseToast({severity:'warn', detail: `Please enter credit note quantity!`, life: 3000}))
            }

            if(e.target.value > parseFloat(processCreditNote['creditNoteQty'])){ 
                return dispatch(raiseToast({severity:'warn', detail: `Available quantity is ${processCreditNote.creditNoteQty}`, life: 3000}))
            }
        }

        processCreditNote[e.target.name] = e.target.value 
        setProcessCreditNote({...processCreditNote})
    }

    const handleCreditNoteDocNoSearch = async () => {
        if(!processCreditNote.crediNoteDocNo){
            return dispatch(raiseToast({severity:'warn', detail: `Please enter credit note doc number`, life: 3000}))
        }

        setIsLoading(true)

        const creditNoteRes = await getCreditNotesWithRejectedStock(processCreditNote.crediNoteDocNo)

        if(creditNoteRes.failure){
            setIsLoading(false)
            return dispatch(raiseToast({severity:'error', summary: 'creditNoteRes', detail: creditNoteRes.data.error, life: 3000}))
        }

        console.log("creditNoteRes.data", creditNoteRes.data)

        if(creditNoteRes.data?.length === 0){
            return dispatch(raiseToast({severity:'warn', detail: `No products were found for the credit note`, life: 3000}))
        }
        else if(creditNoteRes.data?.length > 0){
            const materialIds = creditNoteRes.data.map(eachNoteItem => {return {materialId: eachNoteItem.materialId}})
            setMaterialDetails(materialIds)
        }

        setCreditNoteItems(creditNoteRes.data)
        setIsLoading(false)
    }

    const handleProcessCreditNoteSubmit = async () => {
        const validationRes = await validateInputs(processCreditNoteValidationSchema, processCreditNote)
        console.log("validationRes", validationRes)
        if (validationRes) {
            if (validationRes.error) {
                setFormErrors(validationRes.error)
            }
            else {
                setFormErrors({})

                if(window.confirm("Are you sure you want to continue?")){

                }
                //setProcessCreditNote(processCreditNoteInitialValues)
            }
        }
    }

    return(
        <>
            <Loading visible={isLoading} />
            <div className="flex flex-wrap">
                <div className="flex flex-row col-12 p-0">
                    <div className="flex flex-column col-12 lg:col-3 lg:mb-0">
                        <TextInputField name="crediNoteDocNo" labelText="Credit Note Doc no" keyfilter={"pnum"} value={processCreditNote.crediNoteDocNo} onChange={(e) => handleProcessCreditNoteChange(e)} errorMessage={formErrors.crediNoteDocNo} maxLength={15} required />
                    </div>
                    <div className="flex flex-column col-2 w-3rem align-items-center mt-3 px-0">
                        <Button icon="pi pi-search" className="" style={{ height: "35px"}} onClick={handleCreditNoteDocNoSearch} disabled={!processCreditNote.crediNoteDocNo || processCreditNote.crediNoteDocNo?.length < 11 || isLoading} />
                    </div>
                </div>
                <div className="flex flex-row col-12 p-0">
                    <div className="flex flex-column col-12 lg:col-3 lg:mb-0">
                        <DropDownField name="materialId" labelText="Material ID"  options={materialDetails} value={processCreditNote.materialId}  optionLabel="materialId" optionValue="materialId" onChange={(e) => handleProcessCreditNoteChange(e)} errorMessage={formErrors.materialId} required />
                    </div>
                    <div className="flex flex-column col-12 lg:col-3 lg:mb-0">
                        <TextInputField name="creditNoteQty" labelText="Credit Note Qty" value={processCreditNote.creditNoteQty} errorMessage={formErrors.creditNoteQty} disabled required />
                    </div>
                    <div className="flex flex-column col-12 lg:col-3 lg:mb-0">
                        <TextInputField name="processedQty" labelText="Rejected Qty" keyfilter={"pnum"} value={processCreditNote.processedQty} onChange={(e) => handleProcessCreditNoteChange(e)} errorMessage={formErrors.processedQty} required />
                    </div>
                </div>
                <div className="flex flex-column col-12 text-area">
                    <TextAreaField name="remarks" labelText="Remarks" rows={3} onChange={(e) => handleProcessCreditNoteChange(e)} value={processCreditNote.remarks} errorMessage={formErrors.remarks} required />
                </div>
            </div>
            <div className='flex justify-content-center align-items-center mt-2'>
                <Button label="Submit" onClick={handleProcessCreditNoteSubmit} />
            </div>
        </>
    )
}

export default ProcesCreditNote